import React from "react"
import { Modal } from "react-bootstrap"
import PrimaryButton from "../subComponents/PrimaryButton"
import SecondaryButton from "../subComponents/SecondaryButton"

type Props = {
  show: boolean
  title: string
  message: React.ReactNode
  confirmLabel?: string
  loadingLabel?: string
  isLoading?: boolean
  danger?: boolean
  onConfirm: () => void
  onClose: () => void
}

const ConfirmModal = ({
  show,
  title,
  message,
  confirmLabel = "Confirm",
  loadingLabel = "Please wait...",
  isLoading = false,
  danger = false,
  onConfirm,
  onClose,
}: Props) => {
  return (
    <Modal
      className='comman-modal'
      show={show}
      onHide={() => {
        if (!isLoading) onClose()
      }}
      backdrop={isLoading ? "static" : true}
      keyboard={!isLoading}
      centered
    >
      <Modal.Header closeButton={!isLoading} className='comman-modal-header'>
        <Modal.Title className='comman-modal-title'>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body className='comman-modal-body'>
        <p>{message}</p>
        <div className='d-flex gap-3 justify-content-center mt-3'>
          <SecondaryButton
            type='button'
            label='Cancel'
            className='editFormButton'
            onClick={onClose}
            disabled={isLoading}
          />
          <PrimaryButton
            type='button'
            label={isLoading ? loadingLabel : confirmLabel}
            className={`editFormButton ${danger ? "dangerButton" : ""}`}
            onClick={onConfirm}
            disabled={isLoading}
          />
        </div>
      </Modal.Body>
    </Modal>
  )
}

export default ConfirmModal
